import { render, staticRenderFns } from "./ManualRulesGrid.vue?vue&type=template&id=4c7f6e97&scoped=true&"
import script from "./ManualRulesGrid.vue?vue&type=script&lang=ts&"
export * from "./ManualRulesGrid.vue?vue&type=script&lang=ts&"
import style0 from "./ManualRulesGrid.vue?vue&type=style&index=0&id=4c7f6e97&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7f6e97",
  null
  
)

export default component.exports